// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__bZSKN","log":"ModalInventoryLogs_log__KDuNN","date":"ModalInventoryLogs_date__3ruub","userName":"ModalInventoryLogs_userName__2nSxO"};